import style from "./transaction-layout.module.css";
import clsx from "clsx";
type TLayoutProps = {
  children: React.ReactNode;
};

export const TransactionLayout = ({ children }: TLayoutProps) => {
  return (
    <div className={clsx(style.layout, style["common-page-layout"])}>
      {children}
    </div>
  );
};
